

import React from "react";

import {
    BrowserRouter,
    Switch,
    Redirect,
    Route,
    Link,
    NavLink
} from "react-router-dom";

import { GoBack } from './GoBack.jsx'

function themedSrc(src, pathname) {
    if (!src) return src;
    if (pathname && pathname.startsWith('/poker')) return src;
    if (casino.utils.getCasinoTheme() !== "dark") return src;
    var dotIndex = src.lastIndexOf(".");
    if (dotIndex === -1) return src + "-dark";
    return src.substring(0, dotIndex) + "-dark" + src.substring(dotIndex);
}

export class HeaderMobile extends React.Component {

    constructor(props) {
        super(props);
        this.state = {}

        this.renderUserPart = this.renderUserPart.bind(this);
        this.renderDefault = this.renderDefault.bind(this);
        this.renderUser = this.renderUser.bind(this);
        this.renderDetails = this.renderDetails.bind(this);
        this.renderPoruke = this.renderPoruke.bind(this);
        this.onThemeChange = this.onThemeChange.bind(this);
        this.header = React.createRef();
    }

    onThemeChange() {
        this.forceUpdate();
    }

    componentDidMount() {
        window.addEventListener("casinoThemeChange", this.onThemeChange);
    }

    componentWillUnmount() {
        window.removeEventListener("casinoThemeChange", this.onThemeChange);
    }

    //switchCurrency(e) {
    //    let currency = e.target.checked ? 'eur' : 'kn';
    //    let currencyisEuro = currency == 'eur' ? true : false;
    //    localStorage.setItem('activeCurrency', currency);
    //    this.props.changeCurrency(currencyisEuro);
    //    location.reload();
    //}

    renderUserPart() {

        if (casino.config.fromNativeApp)
            return null;


        return <div className="user-part">
            <div className={this.props.userChecked ? '' : 'hidden'} style={{ display: 'flex', flexDirection: 'row-reverse'}}>
                <div className={this.props.user ? 'hidden' : ''}>
                    <NavLink className="btn fill small red prijava pull-right center-verticaly"
                        to={{ pathname: this.props.getHomePathFn(this.props.route.location, '/login'), state: { from: this.props.route.location.pathname } }}
                        onClick={() => this.props.showSearchFn && this.props.showSearchFn(false)}>
                        Prijava            </NavLink>
                    
                </div>
                <div className={this.props.user ? '' : 'hidden'}>


                    <NavLink className="account pull-right" onClick={() => this.props.showMenuFn(false)} to={this.props.getHomePathFn(this.props.route.location, '/account')}>
                        <img src={themedSrc("content/images/obavijesti/ic_profile_avatar_new.png", this.props.route.location.pathname)} />
                        {/*<span className={"broj-notifikacija " + (this.props.important ? "important" : (this.props.brojNotifikacija ? "active" : "inactive"))}></span>*/}
                        <span className={this.props.route.location.pathname.includes('/account') ? "selected" : ""}></span>
                    </NavLink>

                    <NavLink className="account pull-right" onClick={() => this.props.showMenuFn(false)} to={this.props.getHomePathFn(this.props.route.location, '/obavijesti')}>
                        <img src={themedSrc("content/images/obavijesti/ic_notification_bel_new.png", this.props.route.location.pathname)} />
                        <span className={"broj-notifikacija " + (this.props.important ? "important" : (this.props.brojNotifikacija ? "active" : "inactive"))}>{/*{this.props.important ? "!" : this.props.brojNotifikacija}*/}</span>
                        <span className={this.props.route.location.pathname.includes('/obavijesti') ? "selected" : ""}></span>
                    </NavLink>

                    {/*<NavLink className="account pull-right" onClick={() => this.props.showMenuFn(false)} to={this.props.getHomePathFn(this.props.route.location, '/super-story')}>*/}
                    {/*    <img src="content/images/obavijesti/ic_profile_story@3x.png" />*/}
                    {/*    <span className={"broj-notifikacija " + (this.props.important ? "important" : (this.props.stories ? "active" : "inactive"))}></span>*/}
                    {/*    <span className={this.props.route.location.pathname.includes('/super-story') ? "selected" : ""}></span>*/}
                    {/*</NavLink>*/}

                    {/*{(this.props.user && this.props.user.playerHasBonusOffer) && <NavLink className="bonus-header pull-right" onClick={() => this.props.showMenuFn(false)} to={this.props.getHomePathFn(this.props.route.location, '/account/bonuses')}>*/}
                    {/*    <img src="content/images/obavijesti/bonus@3x.png" style={{ height: "38px" }} />*/}
                    {/*</NavLink>}*/}


                    {/* <span className="text-ellipsis nadimak small-mobile-hidden">{this.props.user && this.props.user.nadimak}</span> */}
                </div>

                <NavLink className="account pull-right" onClick={() => this.props.showMenuFn(false)} to={this.props.getHomePathFn(this.props.route.location, '/super-story')}>
                    <img src={themedSrc("content/images/obavijesti/ic_profile_story_new.png", this.props.route.location.pathname)} />
                    {this.props.user && <span className={"broj-notifikacija " + (this.props.important ? "important" : (this.props.stories ? "active" : "inactive"))}></span>}
                    <span className={this.props.route.location.pathname.includes('/super-story') ? "selected" : ""}></span>
                </NavLink>
            </div>
        </div>
    }

    renderDefault() {
        return (
            <div className="clearfix" ref={this.header} onClick={() => this.props.showSearchFn && this.props.showSearchFn(false)}>

                {this.renderPoruke()}

                <div className="relative">

                    <NavLink to={this.props.getHomePathFn(this.props.route.location)} onClick={() => this.props.showMenuFn(false)} className="logo">
                        <Switch>
                            <Route path='/poker' render={(route) =>
                            //<span className="icon ico-supersport-logo" />
                            (<>
                                <img src={themedSrc("content/images/assets/SuperPoker_red.png", this.props.route.location.pathname)} className="logo-png icon" alt="SuperPoker"></img>
                                <span className="text text-bigger">Poker</span>
                            </>)} />
                            <Route path='/info/poker' render={(route) =>
                            (<>
                                <span className="icon ico-supersport-logo" />
                                <span className="text text-bigger">Poker</span>
                            </>)} />
                            <Route render={(route) =>
                            (<>
                                <picture>
                                    <source srcSet={casino.utils.getCasinoTheme() === "dark" ? "Content/Images/Assets/SuperCasinoLogoWhite.avif" : "Content/Images/Assets/SuperCasinoLogoRed.avif"} type="image/avif" />
                                    <source srcSet={casino.utils.getCasinoTheme() === "dark" ? "Content/Images/Assets/SuperCasinoLogoWhite.webp" : "Content/Images/Assets/SuperCasinoLogoRed.webp"} type="image/webp" />                                    
                                    <img src={casino.utils.getCasinoTheme() === "dark" ? "Content/Images/Assets/SuperCasinoLogoWhite.png" : "Content/Images/Assets/SuperCasinoLogoRed.png"} className="logo-png icon" alt="SuperCasino"></img>
                                </picture>
                            </>)} />
                        </Switch>

                    </NavLink>

                    {this.renderUserPart()}
                </div>

            </div>);

    }
    renderUser(backUrl, headerText, showLogout = true) {
        return (
            <div className="clearfix" ref={this.header} onClick={() => this.props.showSearchFn && this.props.showSearchFn(false)}>

                {this.renderPoruke()}

                <div className="relative">
                    <GoBack toUrl={backUrl} className="pull-left first-btn" disableBrowserBack={this.props.disableBrowserBack}>
                        <span className="icon ico-back ico-arrow-back"></span>
                    </GoBack>


                    {showLogout ?
                        <div className="pull-right user-part">
                            <div className={this.props.userChecked ? '' : 'hidden'}>
                                <div className={this.props.user ? '' : 'hidden'}>
                                    <button className="btn fill small blue odjava center-verticaly pull-right" onClick={() => this.props.logoutFn(true)}>
                                        Odjavi me
                                    </button>
                                </div>
                            </div>
                        </div> :
                        this.renderUserPart()}

                    <div className="logo user-menu-back-text text-ellipsis">
                        <span className="text text-ellipsis">{headerText}</span>
                    </div>
                </div>
            </div>);

    }
    renderDetails(backUrl, headerText) {
        return this.renderUser(backUrl, headerText, false);
    }
    renderPoruke() {



        return <div className="poruke">
            <NavLink to='/poker/bonuses/poker-reload' >
                <div className="novo-banner">
                    <div className="novo-banner-poker "></div>
                </div>
            </NavLink>

            <div className="poruka-banner">
                <div className="novo-banner-upgrade">
                    <span className="icon ico-info"></span> <span>{this.props.ugaseneIgrePoruka}</span>
                </div>
                {/* <a href="javascript:void(0)" className="novo-banner-close" onClick={() => this.props.sakrijNovoBannerFn()}></a> */}
            </div>

        </div>


    }
    render() {
        if (this.props.userHeader) {
            return this.renderUser(this.props.headerBackUrl, this.props.headerText);
        }
        if (this.props.detailsHeader) {
            return this.renderDetails(this.props.headerBackUrl, this.props.headerText);
        }
        return this.renderDefault();
    }
};
 